<template>
  <div>
    <h1>Team</h1>
    <p>
      <v-btn :to="{ name: 'teams' }">
        <v-icon>chevron_left</v-icon>Teams
      </v-btn>
      <v-btn @click="updateReferences">Update references</v-btn>
      <v-btn
        :to="{ name: 'emailClients', params: { id: team.id } }"
        v-if="team"
      >
        <v-icon>send</v-icon>Email clients
      </v-btn>
    </p>
    <template v-if="team">
      <h2>Information</h2>
      <v-text-field label="Code" v-model="team.code" outline />
      <v-text-field label="Name" v-model="team.name" outline />
      <v-text-field
        label="Old id"
        v-model="team.oldEntityId"
        :readonly="true"
        outline
      />
      <v-checkbox label="Archived" v-model="team.archived" />
      <v-checkbox
        label="Overwrite branch phone/fax"
        v-model="team.overwriteBranchPhoneFax"
      />
      <v-checkbox
        label="Overwrite staff name"
        v-model="team.overwriteStaffName"
      />
      <v-checkbox
        label="Overwrite staff role"
        v-model="team.overwriteStaffRole"
      />
      <v-checkbox
        label="Overwrite staff email"
        v-model="team.overwriteStaffEmail"
      />
      <v-checkbox label="Email OS1" v-model="team.emailOs1" />
      <v-btn @click="saveTeam"> <v-icon>save</v-icon>Save </v-btn>
    </template>
    <template v-if="$route.params.id">
      <br />
      <br />
      <h2>Leader</h2>
      <v-btn @click="panelLeaders = !panelLeaders">
        <v-icon>add</v-icon>Leader
      </v-btn>
      <v-card v-if="panelLeaders">
        <v-card-text>
          <v-select
            label="Choose new leader"
            :items="conveyancers"
            v-model="leaderId"
            item-value="id"
            item-text="name"
            outline
          />
          <v-btn @click="createLeader"> <v-icon>save</v-icon>Save </v-btn>
          <v-alert :value="alertLeader" color="error">{{
            alertLeader
          }}</v-alert>
        </v-card-text>
      </v-card>
      <v-data-table
        :headers="headersEntities"
        :items="computedTeamLeaders"
        hide-actions
        class="elevation-1"
        v-if="computedTeamLeaders"
      >
        <template v-slot:items="props">
          <td>
            <EntityZ v-if="props.item.entity" :entity="props.item.entity" />
            <span v-if="!props.item.entity">{{ props.item.entityid }}</span>
          </td>
          <td>{{ props.item.archived | formatDateTime }}</td>
        </template>
      </v-data-table>
      <br />
      <br />
      <h2>Members</h2>
      <v-btn @click="panelMembers = !panelMembers">
        <v-icon>add</v-icon>Member
      </v-btn>
      <v-card v-if="panelMembers">
        <v-card-text>
          <v-select
            label="Choose new member"
            :items="conveyancers"
            v-model="memberId"
            item-value="id"
            item-text="name"
            outline
          />
          <v-btn @click="createMember"> <v-icon>save</v-icon>Save </v-btn>
          <v-alert :value="alertMember" color="error">{{
            alertMember
          }}</v-alert>
        </v-card-text>
      </v-card>
      <v-data-table
        :headers="headersEntities"
        :items="computedTeamMembers"
        hide-actions
        class="elevation-1"
        v-if="computedTeamMembers"
      >
        <template v-slot:items="props">
          <td>
            <EntityZ v-if="props.item.entity" :entity="props.item.entity" />
            <span v-if="!props.item.entity">{{ props.item.entityid }}</span>
          </td>
          <td>{{ props.item.archived | formatDateTime }}</td>
          <td>
            <v-btn @click="deleteMember(props.item)">{{
              props.item.archived ? "Unarchive" : "Archive"
            }}</v-btn>
          </td>
        </template>
      </v-data-table>
      <br />
      <br />
      <h2>Details</h2>
      <v-btn @click="panelDetails = !panelDetails">
        <v-icon>add</v-icon>Detail
      </v-btn>
      <v-card v-if="panelDetails">
        <v-card-text>
          <v-select
            label="Choose detail type"
            :items="detailTypes"
            v-model="detailTypeId"
            item-value="id"
            item-text="name"
            outline
          />
          <v-text-field v-model="detailBody" label="Body" outline />
          <v-btn @click="createDetail"> <v-icon>save</v-icon>Save </v-btn>
          <v-alert :value="alertDetail" color="error">{{
            alertDetail
          }}</v-alert>
        </v-card-text>
      </v-card>
      <v-data-table
        :headers="headersDetails"
        :items="computedTeamDetails"
        hide-actions
        class="elevation-1"
        v-if="computedTeamDetails"
      >
        <template v-slot:items="props">
          <td>
            <span v-if="props.item.detailType">{{
              props.item.detailType.name
            }}</span>
            <span v-if="!props.item.detailType">{{
              props.item.detailtypeid
            }}</span>
          </td>
          <td>{{ props.item.body }}</td>
          <td>{{ props.item.archived | formatDateTime }}</td>
          <td>
            <v-btn @click="deleteDetail(props.item)">{{
              props.item.archived ? "Unarchive" : "Archive"
            }}</v-btn>
          </td>
        </template>
      </v-data-table>
      <br />
      <br />
      <h2>Branch</h2>
      <v-btn @click="panelBranches = !panelBranches">
        <v-icon>add</v-icon>Branch
      </v-btn>
      <v-card v-if="panelBranches">
        <v-card-text>
          <v-select
            label="Choose new branch"
            :items="branches"
            v-model="branchId"
            item-value="id"
            item-text="name"
            outline
          />
          <v-btn @click="createBranch"> <v-icon>add</v-icon>Branch </v-btn>
          <v-alert :value="alertBranch" color="error">{{
            alertBranch
          }}</v-alert>
        </v-card-text>
      </v-card>
      <v-data-table
        :headers="headersEntities"
        :items="computedTeamBranches"
        hide-actions
        class="elevation-1"
        v-if="computedTeamBranches"
      >
        <template v-slot:items="props">
          <td>
            <EntityZ v-if="props.item.entity" :entity="props.item.entity" />
            <span v-if="!props.item.entity">{{ props.item.entityid }}</span>
          </td>
          <td>{{ props.item.archived | formatDateTime }}</td>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="generatingVisible" persistent width="300">
      <v-card color="error" dark>
        <v-card-text>
          <span>{{ generatingContent }}</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :multi-line="false"
      :timeout="1500"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
function initialState() {
  return {
    team: null,
    teamLeaders: null,
    teamMembers: null,
    teamDetails: null,
    teamBranches: null,
    conveyancers: null,
    branches: null,
    detailTypes: null,
    leaderId: null,
    memberId: null,
    detailTypeId: null,
    detailBody: null,
    branchId: null,
    alertLeader: null,
    alertMember: null,
    alertDetail: null,
    alertBranch: null,
    panelLeaders: false,
    panelMembers: false,
    panelDetails: false,
    panelBranches: false,
    headersEntities: [
      {
        text: "Name",
        value: "entity.name"
      },
      {
        text: "Archived",
        value: "archived"
      }
    ],
    paginationEntities: { sortBy: "archived", rowsPerPage: -1 },
    headersDetails: [
      {
        text: "Detail type",
        value: "detailType.name"
      },
      {
        text: "Body",
        value: "body"
      },
      {
        text: "Archived",
        value: "archived"
      },
      { text: "", sortable: false }
    ],
    paginationDetails: { sortBy: "detailType.name", rowsPerPage: -1 },
    generatingVisible: false,
    generatingContent: null,
    snackbar: false,
    snackbarText: null
  };
}
export default {
  name: "Team",
  metaInfo() {
    return {
      title: "Team",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  computed: {
    computedConveyancers() {
      return this.conveyancers
        ? convertListOfObjectsToMap(this.conveyancers, "id")
        : undefined;
    },
    computedTeamLeaders() {
      if (!this.teamLeaders) {
        return undefined;
      }
      return this.teamLeaders.map((l) => {
        const entity = this.computedConveyancers
          ? this.computedConveyancers[l.entityid]
          : undefined;
        return { ...l, entity };
      });
    },
    computedTeamMembers() {
      if (!this.teamMembers) {
        return undefined;
      }
      return this.teamMembers.map((m) => {
        const entity = this.computedConveyancers
          ? this.computedConveyancers[m.entityid]
          : undefined;
        return { ...m, entity };
      });
    },
    computedTeamDetails() {
      if (!this.teamDetails) {
        return undefined;
      }
      const detailTypesMap = this.detailTypes
        ? convertListOfObjectsToMap(this.detailTypes, "id")
        : undefined;
      return this.teamDetails.map((d) => {
        const detailType = detailTypesMap
          ? detailTypesMap[d.detailtypeid]
          : undefined;
        return { ...d, detailType };
      });
    },
    computedTeamBranches() {
      if (!this.teamBranches) {
        return undefined;
      }
      const branchesMap = this.branches
        ? convertListOfObjectsToMap(this.branches, "id")
        : undefined;
      return this.teamBranches.map((d) => {
        const entity = branchesMap ? branchesMap[d.entityid] : undefined;
        return { ...d, entity };
      });
    }
  },
  data: function () {
    return initialState();
  },
  methods: {
    async fetchTeam() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/teams/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.team = response.data;
    },
    async fetchTeamLeaders() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/teams/${this.$route.params.id}/leaders`
      );
      // console.log(response.data);
      this.teamLeaders = response.data;
    },
    async fetchTeamMembers() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/teams/${this.$route.params.id}/members`
      );
      // console.log(response.data);
      this.teamMembers = response.data;
    },
    async fetchTeamDetails() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/teams/${this.$route.params.id}/details`
      );
      // console.log(response.data);
      this.teamDetails = response.data;
    },
    async fetchTeamBranches() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/teams/${this.$route.params.id}/branches`
      );
      // console.log(response.data);
      this.teamBranches = response.data;
    },
    async fetchConveyancers() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/2/entities`
      );
      // console.log(response.data);
      this.conveyancers = response.data;
    },
    async fetchDetailTypes() {
      const response = await nbmlaw.get(`/cors/admin/directory/detailTypes`);
      // console.log(response.data);
      this.detailTypes = response.data;
    },
    async fetchBranches() {
      const response = await nbmlaw.get(`/cors/admin/directory/branches`);
      // console.log(response.data);
      this.branches = response.data;
    },
    async updateReferences() {
      this.generatingVisible = true;
      this.generatingContent = "Waiting for server to update references...";
      await nbmlaw.put(
        `/cors/admin/directory/teams/${this.$route.params.id}/updateReferences`,
        null
      );
      // console.log(response.data);
      this.generatingVisible = false;
      this.snackbar = true;
      this.snackbarText = "References updated";
    },
    saveTeam() {
      if (this.$route.params.id) {
        this.updateTeam();
      } else {
        this.createTeam();
      }
    },
    async createTeam() {
      await nbmlaw.post(`/cors/admin/directory/teams`, this.team);
      // console.log(response.data);
      this.$router.push({ name: "teams" });
    },
    async updateTeam() {
      await nbmlaw.put(
        `/cors/admin/directory/teams/${this.$route.params.id}`,
        this.team
      );
      // console.log(response.data);
      this.$router.push({ name: "teams" });
    },
    async createLeader() {
      if (!this.leaderId) {
        this.alertLeader = "Please fill in the form";
        return;
      }
      try {
        await nbmlaw.post(
          `/cors/admin/directory/teams/${this.$route.params.id}/leaders`,
          null,
          { params: { entityid: this.leaderId } }
        );
        // console.log(response.data);
        this.resetLeader();
      } catch (error) {
        this.alertLeader = error.response.data;
      }
    },
    async createMember() {
      if (!this.memberId) {
        this.alertMember = "Please fill in the form";
        return;
      }
      try {
        await nbmlaw.post(
          `/cors/admin/directory/teams/${this.$route.params.id}/members`,
          null,
          { params: { entityid: this.memberId } }
        );
        // console.log(response.data);
        this.resetMember();
      } catch (error) {
        this.alertMember = error.response.data;
      }
    },
    async createDetail() {
      if (!this.detailBody || !this.detailTypeId) {
        this.alertDetail = "Please fill in the form";
        return;
      }
      try {
        await nbmlaw.post(
          `/cors/admin/directory/teams/${this.$route.params.id}/details`,
          this.detailBody,
          { params: { detailtypeid: this.detailTypeId } }
        );
        // console.log(response.data);
        this.resetDetail();
      } catch (error) {
        this.alertDetail = error.response.data;
      }
    },
    async createBranch() {
      if (!this.branchId) {
        this.alertBranch = "Please fill in the form";
        return;
      }
      try {
        await nbmlaw.post(
          `/cors/admin/directory/teams/${this.$route.params.id}/branches`,
          null,
          { params: { entityid: this.branchId } }
        );
        // console.log(response.data);
        this.resetBranch();
      } catch (error) {
        this.alertBranch = error.response.data;
      }
    },
    async deleteMember(detail) {
      await nbmlaw.delete(`/cors/admin/directory/teamMembers/${detail.id}`);
      this.fetchTeamMembers();
    },
    async deleteDetail(detail) {
      await nbmlaw.delete(`/cors/admin/directory/teamDetails/${detail.id}`);
      this.fetchTeamDetails();
    },
    resetLeader() {
      this.alertLeader = null;
      this.panelLeaders = false;
      this.leaderId = null;
      this.fetchTeamLeaders();
    },
    resetMember() {
      this.alertMember = null;
      this.panelMembers = false;
      this.memberId = null;
      this.fetchTeamMembers();
    },
    resetDetail() {
      this.alertDetail = null;
      this.panelDetails = false;
      this.detailBody = null;
      this.detailTypeId = null;
      this.fetchTeamDetails();
    },
    resetBranch() {
      this.alertBranch = null;
      this.panelBranches = false;
      this.branchId = null;
      this.fetchTeamBranches();
    },
    update() {
      Object.assign(this.$data, initialState());
      if (this.$route.params.id) {
        this.fetchTeam();
        this.fetchTeamLeaders();
        this.fetchTeamMembers();
        this.fetchTeamDetails();
        this.fetchTeamBranches();
      } else {
        this.team = {};
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    }
  },
  created() {
    this.fetchConveyancers();
    this.fetchBranches();
    this.fetchDetailTypes();
  }
};
</script>

<style>
</style>
